export const version = 'fet.0.44.1';



// WEBPACK FOOTER //
// /opt/snt/front-end-turnos/src/environments/version.ts